// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c37bba67","488":"fa2c41a8"}[chunkId] + ".chunk.js";
};